import { GridColumn } from '../types/grid.types'

export type CellAlign = 'start' | 'end' | 'center'

/**
 * Explicit `align` wins (mapped to logical start/end). Otherwise everything
 * hugs the start edge — in RTL that's the right side, so all columns (text and
 * numeric alike) read right-to-left by default.
 */
export const resolveAlign = <T,>(col: GridColumn<T>): CellAlign => {
  if (col.align === 'center') return 'center'
  if (col.align === 'right') return 'end'
  if (col.align === 'left') return 'start'
  return 'start'
}
